import * as React from 'react';
import { RankItem } from '@/fetch.ts';
import defaultAvatar from '@images/default.png';
interface Props extends RankItem {
  index: number,
}
const HourItem: React.FC<Props> = props => (
  <div
    className='hour-item'
    style={
      {
        justifyContent: props.index > 6 ? 'flex-end' : 'flex-start',
      }
    }
  >
    <div className='avatar'>
      <img
        src={props.sLogoUrl}
        title={props.sNickName}
        onError={(event: any): void => {
          event.target.onerror = null;
          event.target.src = defaultAvatar;
        }}
        onClick={(): void => {
          window.open('https://m.huya.com/' + props.tJump.iRoomId, '_blank');
        }}
      />
    </div>
    <p
      onClick={(): void => {
        window.open('https://m.huya.com/' + props.tJump.iRoomId, '_blank');
      }}
    >{props.sNickName}</p>
  </div>
)

export default HourItem;